/**
 * エラーメッセージ
 */
import React from 'react';

type Props = {
  children: React.ReactNode;
};

const ErrorMessage = ({ children }: Props) => {
  return <p className='text-xs text-warning-500'>{children}</p>;
};

export default ErrorMessage;
